module.exports = __webpack_public_path__ + "img/ReviewOrderBarStatus.5e8b863c.png";